import { AgeRangeEnumType } from "@libs/api/patients";
import { SpecialConditionsEnum } from "@/domain/eligibility";
import { i18n, I18nKeyType } from "@/i18n";

import { dateAsDayjs, DateType } from "./date";

export const getSpecialConditionsFieldLabel = (
  statusField: SpecialConditionsEnum,
): I18nKeyType => {
  switch (statusField) {
    case SpecialConditionsEnum.PREGNANT_STATUS:
      return "native:eligibilitySpecialConditionsScreen.conditions.pregnant";
    case SpecialConditionsEnum.BREAST_CANCER_STATUS:
      return "native:eligibilitySpecialConditionsScreen.conditions.breastCancer";
    case SpecialConditionsEnum.CERVICAL_CANCER_STATUS:
      return "native:eligibilitySpecialConditionsScreen.conditions.cervicalCancer";
    case SpecialConditionsEnum.BLIND_OR_VISION_LOSS_STATUS:
      return "native:eligibilitySpecialConditionsScreen.conditions.blind";
    case SpecialConditionsEnum.DISABLED_STATUS:
      return "native:eligibilitySpecialConditionsScreen.conditions.disabled";
    case SpecialConditionsEnum.FOSTER_CARE_FORMERLY_STATUS:
      return "native:eligibilitySpecialConditionsScreen.conditions.fosterCare";
  }
};

export const getSomeoneSupportsYouOptions = () => {
  return [
    i18n.t("native:eligibilitySomeoneSupportsYou.options.fullTimeStudent"),
    i18n.t("native:eligibilitySomeoneSupportsYou.options.personSupportsMe"),
    i18n.t("native:eligibilitySomeoneSupportsYou.options.disabled"),
    i18n.t("native:eligibilitySomeoneSupportsYou.options.relativeSupportsMe"),
  ];
};

export const convertDateOfBirthToAgeRange = (
  dateOfBirth: DateType | null,
): AgeRangeEnumType | null => {
  if (!dateOfBirth) {
    return null;
  }

  const today = dateAsDayjs();
  const birthDate = dateAsDayjs(dateOfBirth);
  const age = today.diff(birthDate, "year");

  if (age >= 0 && age <= 1) {
    return "BABY";
  } else if (age > 1 && age <= 5) {
    return "CHILD";
  } else if (age > 5 && age <= 18) {
    return "YOUTH";
  } else if (age >= 19 && age <= 20) {
    return "YOUNG_ADULT";
  } else if (age > 20 && age <= 63) {
    return "ADULT";
  } else if (age === 64) {
    return "TURNING_SENIOR";
  } else if (age >= 65) {
    return "SENIOR";
  } else {
    return null;
  }
};
